<template>
  <button
    type="button"
    @click="handleClickCard"
    class="group w-full min-w-0 flex items-center gap-3 rounded-xl border border-untitled-gray-200 bg-app-white p-2 xl:p-4 text-left hover:border-app-primary/40 hover:shadow-sm transition-all"
  >
    <div
      class="items-center hidden sm:hidden md:flex lg:hidden 2xl:flex justify-center w-9 h-9 rounded-lg bg-app-primary/10 text-app-primary shrink-0"
    >
      <CheckCircleIcon
        v-if="stat.key === 'courses_completed_count'"
        class="w-5 h-5"
      />
      <ClockIcon
        v-else-if="stat.key === 'courses_in_progress_count'"
        class="w-5 h-5"
      />
      <ClipboardListIcon
        v-else-if="stat.key === 'total_assigned_count'"
        class="w-5 h-5"
      />
      <AcademicCapIcon
        v-else-if="stat.key === 'total_certificates_count'"
        class="w-5 h-5"
      />
      <ChartBarIcon v-else class="w-5 h-5" />
    </div>

    <div class="flex-1 min-w-0">
      <p class="text-2xl font-bold text-app-primary leading-tight">
        {{ stat.value }}
      </p>
      <p class="text-xs font-medium text-untitled-gray-500 mt-0.5 line-clamp-2">
        {{ stat.title }}
      </p>
    </div>

    <ChevronRightIcon
      class="w-4 h-4 text-untitled-gray-300 shrink-0 group-hover:text-app-primary transition-colors"
    />
  </button>
</template>

<script setup>
import { computed } from "vue";
import { defineProps, defineEmits } from "vue";
import {
  CheckCircleIcon,
  ClockIcon,
  ClipboardListIcon,
  AcademicCapIcon,
  ChartBarIcon,
  ChevronRightIcon,
} from "@heroicons/vue/outline";

const emit = defineEmits(["onClickCard"]);

const props = defineProps({
  stat: {
    type: Object,
    required: true,
  },
});

const stat = computed(() => props.stat);

const handleClickCard = () => {
  emit("onClickCard", stat.value.key);
};
</script>

<style scoped></style>
